import './src/styles/fonts.css';
import './src/styles/globals.css'
import './src/styles/common.css'   
import React from 'react';
import RootElement from './src/components/root-element';

export const wrapRootElement = ({ element }) => {
 
    return <RootElement>{element}</RootElement>;
  };
  // export const  shouldUpdateScroll = ({
  //   routerProps: { location },
  //   getSavedScrollPosition,
  // }) => {
  //   const { pathname } = location
  //   // list of routes for the scroll-to-top-hook
  //   const scrollToTopRoutes = [`/contact`, `/contact/`]
  //   // if the new route is part of the list above, scroll to top (0, 0)
  //   if (scrollToTopRoutes.indexOf(pathname) !== -1) {
  //     window.scrollTo(0, 0)
  //   }
  
  //   return false
  // }